import axios, { AxiosRequestConfig } from 'axios';
import { firestore } from '@/firebase';
import { VueConstructor } from 'vue/types/umd';

const request = async (path: string, query: { [key: string]: any }) => {
  const idToken = localStorage.getItem("idToken")
  let queryString = "?"
  for (let key in query) {
    queryString += `${key}=${query[key]}&`
  }
  const _request: AxiosRequestConfig = {
    headers: {
      authorization: `Bearer ${idToken}`
    },
    method: `GET`,
    url: `${process.env.VUE_APP_OAUTH_URL}${path}${queryString}`,
  }
  try {
    const response = await axios(_request)
    return response.data
  } catch (err) {
    if (!err.response) {
      throw {
        message: err,
        code: "network/service-unavailable",
        status: 503
      }
    }
    throw err.response.data
  }
}

const getAuthCode = async (oauthRequest: {clientId:string, redirectUri:string, responseType: string, scope: string[]}) => {
  const code = await request("/code", oauthRequest)
  return code
}

const getClient = async (id:string) => {
    const doc = await firestore.collection("applications").doc(id).get()
    if (!doc.exists) {
      throw {
        code: "oauth/client-not-found",
        message: `The application does not exist or has been deleted. Contact support for the application requesting access.`,
        status: 404
      }
    }
    return {_id: doc.id, ...doc.data()}
}

export default {
  install(Vue: VueConstructor) {
    Vue.prototype.$oauth = { getAuthCode, getClient }
  }
}
